/* global Modernizr */

export const isBrowser = (): boolean => typeof window === 'object';

// if browsers don't support navigator.onLine always return true. be happy :)
export const isOnline = (): boolean =>
    isBrowser() && 'onLine' in window.navigator ? window.navigator.onLine : true;

export const isFullscreen = (): boolean => {
    if (!isBrowser()) {
        return false;
    }

    return !!(
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement ||
        document.webkitCurrentFullScreenElement
    );
};

// No need to check for sessionStorage because same browser support as localstorage.
export const supportsLocalStorage = (): boolean => isBrowser() && Modernizr && Modernizr.localstorage;

export const isInSweden = (): boolean => typeof Modernizr !== 'undefined' && Modernizr.sweden === true;
